/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { OptionDto_Int32 } from '../models/OptionDto_Int32';
import type { PagedResultDto_SandboxResponseDto } from '../models/PagedResultDto_SandboxResponseDto';
import type { Wealthlane_AppServices_Sandbox_CompanySandboxListItemDto } from '../models/Wealthlane_AppServices_Sandbox_CompanySandboxListItemDto';
import type { Wealthlane_AppServices_Sandbox_SandboxCreateDto } from '../models/Wealthlane_AppServices_Sandbox_SandboxCreateDto';
import type { Wealthlane_AppServices_Sandbox_SandboxResponseDto } from '../models/Wealthlane_AppServices_Sandbox_SandboxResponseDto';
import type { Wealthlane_AppServices_Sandbox_SandboxUpdateDto } from '../models/Wealthlane_AppServices_Sandbox_SandboxUpdateDto';
import type { Wealthlane_Shared_Hosting_Dtos_GenericApiResponse } from '../models/Wealthlane_Shared_Hosting_Dtos_GenericApiResponse';
import type { Wealthlane_Shared_Hosting_Dtos_GenericCreatedApiResponse } from '../models/Wealthlane_Shared_Hosting_Dtos_GenericCreatedApiResponse';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class SandboxService {
  /**
   * @param requestBody
   * @returns Wealthlane_Shared_Hosting_Dtos_GenericCreatedApiResponse OK
   * @throws ApiError
   */
  public static postApiIdentityApiSandbox(
    requestBody?: Wealthlane_AppServices_Sandbox_SandboxCreateDto
  ): CancelablePromise<Wealthlane_Shared_Hosting_Dtos_GenericCreatedApiResponse> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/identity/api/sandbox',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request`,
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
        500: `Internal Server Error`,
        501: `Not Implemented`,
      },
    });
  }

  /**
   * @param filter
   * @param sorting
   * @param skipCount
   * @param maxResultCount
   * @returns PagedResultDto_SandboxResponseDto OK
   * @throws ApiError
   */
  public static getApiIdentityApiSandbox(
    filter?: string,
    sorting?: string,
    skipCount?: number,
    maxResultCount?: number
  ): CancelablePromise<PagedResultDto_SandboxResponseDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/identity/api/sandbox',
      query: {
        Filter: filter,
        Sorting: sorting,
        SkipCount: skipCount,
        MaxResultCount: maxResultCount,
      },
      errors: {
        400: `Bad Request`,
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
        500: `Internal Server Error`,
        501: `Not Implemented`,
      },
    });
  }

  /**
   * @param id
   * @returns Wealthlane_AppServices_Sandbox_SandboxResponseDto OK
   * @throws ApiError
   */
  public static getApiIdentityApiSandbox1(
    id: string
  ): CancelablePromise<Wealthlane_AppServices_Sandbox_SandboxResponseDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/identity/api/sandbox/{id}',
      path: {
        id: id,
      },
      errors: {
        400: `Bad Request`,
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
        500: `Internal Server Error`,
        501: `Not Implemented`,
      },
    });
  }

  /**
   * @param id
   * @param requestBody
   * @returns Wealthlane_Shared_Hosting_Dtos_GenericCreatedApiResponse OK
   * @throws ApiError
   */
  public static putApiIdentityApiSandbox(
    id: string,
    requestBody?: Wealthlane_AppServices_Sandbox_SandboxUpdateDto
  ): CancelablePromise<Wealthlane_Shared_Hosting_Dtos_GenericCreatedApiResponse> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/identity/api/sandbox/{id}',
      path: {
        id: id,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request`,
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
        500: `Internal Server Error`,
        501: `Not Implemented`,
      },
    });
  }

  /**
   * @param sandboxId
   * @param requestBody
   * @returns Wealthlane_Shared_Hosting_Dtos_GenericApiResponse OK
   * @throws ApiError
   */
  public static postApiIdentityApiSandboxShare(
    sandboxId: string,
    requestBody?: Array<string>
  ): CancelablePromise<Wealthlane_Shared_Hosting_Dtos_GenericApiResponse> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/identity/api/sandbox/{sandboxId}/share',
      path: {
        sandboxId: sandboxId,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request`,
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
        500: `Internal Server Error`,
        501: `Not Implemented`,
      },
    });
  }

  /**
   * @returns OptionDto_Int32 OK
   * @throws ApiError
   */
  public static getApiIdentityApiSandboxOptionsVisibility(): CancelablePromise<
    Array<OptionDto_Int32>
  > {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/identity/api/sandbox/options/visibility',
      errors: {
        400: `Bad Request`,
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
        500: `Internal Server Error`,
        501: `Not Implemented`,
      },
    });
  }

  /**
   * @param sandboxId
   * @returns Wealthlane_Shared_Hosting_Dtos_GenericApiResponse OK
   * @throws ApiError
   */
  public static putApiIdentityApiSandboxConvert(
    sandboxId?: string
  ): CancelablePromise<Wealthlane_Shared_Hosting_Dtos_GenericApiResponse> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/identity/api/sandbox/convert',
      query: {
        sandboxId: sandboxId,
      },
      errors: {
        400: `Bad Request`,
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
        500: `Internal Server Error`,
        501: `Not Implemented`,
      },
    });
  }

  /**
   * @param sandboxId
   * @returns string OK
   * @throws ApiError
   */
  public static getApiIdentityApiSandboxSharedUsers(
    sandboxId: string
  ): CancelablePromise<Array<string>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/identity/api/sandbox/{sandboxId}/shared-users',
      path: {
        sandboxId: sandboxId,
      },
      errors: {
        400: `Bad Request`,
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
        500: `Internal Server Error`,
        501: `Not Implemented`,
      },
    });
  }

  /**
   * @param companyId
   * @returns Wealthlane_AppServices_Sandbox_CompanySandboxListItemDto OK
   * @throws ApiError
   */
  public static getApiIdentityApiSandboxByCompany(
    companyId: string
  ): CancelablePromise<Array<Wealthlane_AppServices_Sandbox_CompanySandboxListItemDto>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/identity/api/sandbox/by-company/{companyId}',
      path: {
        companyId: companyId,
      },
      errors: {
        400: `Bad Request`,
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
        500: `Internal Server Error`,
        501: `Not Implemented`,
      },
    });
  }
}
